import { Type } from "../actions/types";

export const getSizeNameFromTypes = (types: Type[]): string => {
  const sizeType = types.find((type) =>
    type.name.toLowerCase().includes("talle")
  );
  return sizeType ? sizeType.name : "";
};
